var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UPLO",
    transform: "translate(-245 -397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 24,
    height: 24,
    transform: "translate(245 397)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(249.992 403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_All",
    "data-name": "Download All",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911",
    transform: "translate(3.279 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M-2.428-5.009v-6.834M-6.037-8.335l3.609,3.716L1.184-8.335",
    transform: "translate(6.037 11.843)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M-8.652,0V3.265H-21V0",
    transform: "translate(21.608 6.405)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591-2",
    "data-name": "Path 1591",
    d: "M-7.429,4.8H-21",
    transform: "translate(21 8.769)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591-3",
    "data-name": "Path 1591",
    d: "M-7.429,4.974H-21",
    transform: "translate(21 6.782)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAll);
export default __webpack_public_path__ + "static/media/DownloadAll.89225bca832ae4481871c6f51895329c.svg";
export { ForwardRef as ReactComponent };